// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1PlG4","inputWrap":"styles_inputWrap__2pb3s","input":"styles_input__1dMQi"};